import api from './api';

export const automationService = {
  getAll: (params = {}) => api.get('/automations', { params }),
  getById: (id) => api.get(`/automations/${id}`),
  create: (data) => api.post('/automations', data),
  update: (id, data) => api.put(`/automations/${id}`, data),
  delete: (id) => api.delete(`/automations/${id}`),
  toggle: (id) => api.post(`/automations/${id}/toggle`),
  execute: (id) => api.post(`/automations/${id}/execute`),
  getLogs: (id, params = {}) => api.get(`/automations/${id}/logs`, { params }),
  getStats: () => api.get('/automations/stats/overview'),
  getSchedulerStatus: () => api.get('/automations/scheduler/status'),
};
